<template>
    <v-container fluid grid-list-md>
        <v-form ref="form">
            <!-- category card -->
            <v-card flat>
                <v-card-text>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="onSave()"
                        color="primary"
                        pr-4
                        pb-3>
                        Update</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-container>
</template>
<script>
import ConfigService from '@/services/ConfigService'
import { mapGetters, mapMutations } from 'vuex'
import ConfigItem from './ConfigItem'
export default {
  name: 'SiteConfig',
  components: {
    ConfigItem
  },
  data() {
    return {
      componentKey: 0,
      loaded: false,
      valid: false,
      factorRules: [
        v =>
          (v > 0 && v < 2) || 'Required.  Must be greater than 0, less than 2'
      ],
      saveErr: false,
      onPeakAdjustFactor: '1.3245',
      onPeakThresholdJun: '0.9881',
      onPeakThresholdJul: '1.9999',
      onPeakThresholdAug: '0.0010',
      onPeakThresholdSep: '1.0000'
    }
  },
  computed: {
    ...mapGetters(['getFacilityId', 'getFacilityTimezone', 'hasProgram']),
  },
  created() {
    // fetch
  },
  methods: {
    onSave() {
      // console.log('onPeakAdjustFactor', this.onPeakAdjustFactor)
      // console.log('onPeakThresholdJun', this.onPeakThresholdJun)
      // console.log('onPeakThresholdJul', this.onPeakThresholdJul)
      // console.log('onPeakThresholdAug', this.onPeakThresholdAug)
      // console.log('onPeakThresholdSep', this.onPeakThresholdSep)

        // this.postConfig(this.keys.get('5CP_THRESH'), this.previousMinThres5cp)
        this.$toast.success("Configuration successfully saved.")
        this.componentKey += 1

    },
    
    async getConfig(key) {
      try {
        let response = await ConfigService.getValue(key)
        if (response.data) {
          return response.data.value
        }
      } catch (error) {}
      return null
    },
    
    postConfig(key, value) {
      ConfigService.postValue(key, value)
        // .then(response => {})
        .catch(error => { this.$toast.error("Cannot post updates for key " + key + " " + error.message) })
    }
  }
}
</script>